/*import { createHmac } from 'crypto';

export function signMessage(message: string, secret: string): string {
  return createHmac('sha256', secret).update(message).digest('base64');
}*/

import crypto from 'crypto-js'

export function signMessage(message: string, secret: string): string {
  return crypto.enc.Base64.stringify(crypto.HmacSHA256(message, secret))
}
